import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseDropdown from "@/components/BaseDropdown.vue";
import Card from "@/components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";
import StatsCard from "@/components/Cards/StatsCard.vue";
import BaseButton from "@/components/BaseButton.vue";
import Badge from "@/components/Badge.vue";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseCheckbox from "@/components/Inputs/BaseCheckbox.vue";
import BaseSwitch from "@/components/BaseSwitch.vue";
import BaseRadio from "@/components/Inputs/BaseRadio";
import BaseProgress from "@/components/BaseProgress";
import BasePagination from "@/components/BasePagination";
import BaseAlert from "@/components/BaseAlert";
import BaseNav from "@/components/Navbar/BaseNav";
import BaseHeader from "@/components/BaseHeader";
import Organization from "@/components/Organization";
import ObjectLink from "@/components/ObjectLink";
import Reseller from "@/components/Reseller";
import Locations from "@/components/Locations";
import ServiceCenter from "@/components/ServiceCenter";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Input, Tooltip, Popover } from "element-ui";
import Products from "@/components/Products";
import Supplier from "@/components/Supplier";
import Suppliers from "@/components/Suppliers";
import Warehouse from "@/components/Warehouse";
import Warehouses from "@/components/Warehouses";
import PhoneNumber from "@/components/PhoneNumber";
import HelpButton from "@/components/Trainings/HelpButton.vue";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(HelpButton.name, HelpButton);
    Vue.component(Modal.name, Modal);
    Vue.component(Organization.name, Organization);
    Vue.component(Supplier.name, Supplier);
    Vue.component(ObjectLink.name, ObjectLink);
    Vue.component(Reseller.name, Reseller);
    Vue.component(Locations.name, Locations);
    Vue.component(ServiceCenter.name, ServiceCenter);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(RouteBreadcrumb.name, RouteBreadcrumb);
    Vue.component(Products.name, Products);
    Vue.component(Products.name, Products);
    Vue.component(Supplier.name, Supplier);
    Vue.component(Suppliers.name, Suppliers);
    Vue.component(Warehouse.name, Warehouse);
    Vue.component(Warehouses.name, Warehouses);
    Vue.component(PhoneNumber.name, PhoneNumber);
    Vue.component(Input.name, Input);
    Vue.component("validation-provider", ValidationProvider);
    Vue.component("validation-observer", ValidationObserver);
    Vue.use(Tooltip);
    Vue.use(Popover);
  },
};

export default GlobalComponents;
